import classes from '../style/menu/chatRoom.module.css'


const ChatRoom = () => {



    return <>

             <div className={classes.chatRoom}>
                    chatroom
             </div>


           </>;

}


export default ChatRoom;